// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanTerminationPropertiesDto
 */
export interface IPlanTerminationPropertiesDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanTerminationPropertiesDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanTerminationPropertiesDto
     */
    plan_id: number;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesDto
     */
    termination_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesDto
     */
    coverage_end_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesDto
     */
    claim_last_date: Date;
    /**
     * 
     * @type {string}
     * @memberof IPlanTerminationPropertiesDto
     */
    hsa_transfer_of_assets: IPlanTerminationPropertiesDtoHsaTransferOfAssetsEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesDto
     */
    updated_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IPlanTerminationPropertiesDtoHsaTransferOfAssetsEnum {
    BULK_TRANSFER = 'BULK_TRANSFER',
    EMPLOYEE_OWNED = 'EMPLOYEE_OWNED',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}


/**
 * Check if a given object implements the IPlanTerminationPropertiesDto interface.
 */
export function instanceOfIPlanTerminationPropertiesDto(value: object): value is IPlanTerminationPropertiesDto {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('termination_date' in value) || value['termination_date'] === undefined) return false;
    if (!('claim_last_date' in value) || value['claim_last_date'] === undefined) return false;
    if (!('hsa_transfer_of_assets' in value) || value['hsa_transfer_of_assets'] === undefined) return false;
    return true;
}

export function IPlanTerminationPropertiesDtoFromJSON(json: any): IPlanTerminationPropertiesDto {
    return IPlanTerminationPropertiesDtoFromJSONTyped(json, false);
}

export function IPlanTerminationPropertiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanTerminationPropertiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_id': json['plan_id'],
        'termination_date': (new Date(json['termination_date'])),
        'coverage_end_date': json['coverage_end_date'] == null ? undefined : (new Date(json['coverage_end_date'])),
        'claim_last_date': (new Date(json['claim_last_date'])),
        'hsa_transfer_of_assets': json['hsa_transfer_of_assets'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function IPlanTerminationPropertiesDtoToJSON(json: any): IPlanTerminationPropertiesDto {
    return IPlanTerminationPropertiesDtoToJSONTyped(json, false);
}

export function IPlanTerminationPropertiesDtoToJSONTyped(value?: IPlanTerminationPropertiesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_id': value['plan_id'],
        'termination_date': ((value['termination_date']).toISOString()),
        'coverage_end_date': value['coverage_end_date'] == null ? undefined : ((value['coverage_end_date']).toISOString()),
        'claim_last_date': ((value['claim_last_date']).toISOString()),
        'hsa_transfer_of_assets': value['hsa_transfer_of_assets'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
    };
}

